import { useOracleSearchStore } from '@modules/oracle/store/oracleSearchStore';
import { Status } from 'generated/graphql';
import { useGetUser } from 'v2/core/services/user';

export function useHasChatEditAccess() {
  const { id: userID } = useGetUser();
  const chat = useOracleSearchStore(({ data }) => data.chat);

  if (chat?.status !== Status.Unarchived) {
    return false;
  }

  if (chat.createdBy.id && chat.createdBy.id !== userID) {
    return false;
  }

  return true;
}
